const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M16 18h2V6h-2M6 18l8.5-6L6 6v12Z\"/>"
};
exports.__esModule = true;
exports.default = data;
